import React from 'react';

import { useAppSelector } from 'store/hooks';
import MintWallet from './MintWallet';
import multiplierIcon from '@/assets/emoji/multiplier.png';

const Addr = () => {
  const {
    entries,
    raffleInfo: { status },
  } = useAppSelector((state) => state.raffleDetails);

  return (
    <div className="rounded-2xl bg-neutral-900 p-3 text-center text-base font-normal">
      <div className="text-neutral-400 ">You submitted:</div>
      <div className="mt-2 break-all font-semibold text-neutral-100">
        <MintWallet />
      </div>
      {entries >= 1 && status !== 'FINALIZED' && (
        <div className="relative">
          <div className="peer  mt-2 flex cursor-pointer flex-wrap items-center justify-center gap-1 text-neutral-100">
            {entries} Entries
            <img src={multiplierIcon.src} className="w-5" alt="" />
          </div>
          <div className="absolute top-8 z-20 -mx-3 hidden whitespace-pre-wrap rounded-lg border-2 border-neutral-700 bg-neutral-800 px-2 py-3 text-left  text-sm font-normal text-neutral-200 lg:peer-hover:block">
            The number of your entries for this raffle, based on your role in
            Discord channel and the number of multiplier tokens held in your
            wallet at the time of registration. Note: this number will be
            re-evaluated when the raffle is drawn, so if you changed the tasks
            completion status before then, your changed number of entries will
            be reflected at that time.
          </div>
        </div>
      )}
    </div>
  );
};

export default Addr;
